<template>
  <div class="duel-settings">
    <MusicVolumeSlider />
    <MusicVolumeSlider channel="sfx" />

    <DuelViewerPrefs :show-zoom="duelCompact" />

    <h2>{{ t('settings.mat') }}</h2>
    <p class="hint">{{ t('settings.matHint') }}</p>
    <PlaymatPicker />

    <h2>{{ t('settings.sleeve') }}</h2>
    <p class="hint">{{ t('settings.sleeveHint') }}</p>
    <SleevePicker />
  </div>
</template>

<script setup lang="ts">
import SleevePicker from './SleevePicker.vue'
import PlaymatPicker from './PlaymatPicker.vue'
import MusicVolumeSlider from './MusicVolumeSlider.vue'
import DuelViewerPrefs from './DuelViewerPrefs.vue'
import { useI18n } from '../i18n/t'
import { useCompactLayout } from '../composables/useCompactLayout'

const { t } = useI18n()
const { duelCompact } = useCompactLayout()
</script>

<style scoped>
.duel-settings {
  width: 100%;
  max-height: min(70vh, 560px);
  overflow-y: auto;
  padding: 0 8px 8px;
  color: #e2e8f0;
  font-family: Roboto, system-ui, sans-serif;
}

.hint {
  margin: 0 0 10px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 16px;
}

h2 {
  margin: 16px 0 6px;
  font-size: 13px;
  font-weight: 700;
  color: #f8fafc;
}
</style>
